export const ALERTS_STARTED_LOAD = Object.freeze({
	BASE: 'A continuación añade un documento .xls que incluya la información: espacios, actividades, criterios generales, criterios específicos y frecuencias.',
	PERSONAL:
		'A continuación añade un documento .xls que incluya la información del personal responsable de la supervisión para cada actividad. Recuerda escribir los nombres tal como aparecen en el sistema para asegurar la precisión de la información.',
	RELATIONS:
		'A continuación añade un documento .xls que incluya la información de las relaciones entre los espacios, actividades, criterios generales, criterios específicos, personal y frecuencias.',
});
